import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 12 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 5\" id=\"icon-arrow\">\n    <path fill=\"currentColor\" d=\"M5.252 4.881L.155.927C-.052.77-.052.514.155.357L.467.118c.206-.157.54-.157.747 0l4.411 3.434 4.411-3.43c.207-.158.54-.158.747 0l.312.238c.207.158.207.413 0 .57L5.998 4.886c-.206.154-.54.154-.746-.004z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol